import { NgModule } from '@angular/core';
import { NoPreloading, PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';
import { LoginComponent } from "./login/login.component";
import { authGuard } from './services/auth/auth.guard';
import { NotFoundComponent } from './shared/not-found/not-found.component';
import { ResetPasswordComponent } from './login/reset-password/reset-password.component';
import { guestGuard } from './services/auth/guest.guard';
import { SUPPLIER_PORTAL_PATH } from './home/module-logistics/procurement/supplier-portal/supplier-portal.paths';

const routes: Routes = [
  {
    path: "",
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    canActivate: [authGuard],
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    loadChildren: () => import('./home/profile/profile.module').then(m => m.ProfileModule)
  },
  {
    path: 'user-guide',
    loadChildren: () => import('./user-guide/user-guide.module').then(m => m.UserGuideModule)
  },
  {
    // Public (unauthenticated) digital business card.
    path: "card/:id",
    loadComponent: () => import('./home/profile/business-card/business-card.component').then(c => c.BusinessCardComponent)
  },
  {
    // Guest-facing supplier portal. guestGuard only checks that a guest session is present; the
    // token itself is the server's to accept or reject.
    path: SUPPLIER_PORTAL_PATH,
    canActivate: [guestGuard],
    loadChildren: () => import('./home/module-logistics/procurement/supplier-portal/supplier-portal.module').then(m => m.SupplierPortalModule)
  },
  // The supplier pages used to live at these paths, and the URLs are still in sent invite emails,
  // bookmarks and fabricated shareable links. Relative redirectTo (no leading '/') keeps the query
  // string; ':id' is copied across by position.
  { path: 'rfq-submission', redirectTo: 'supplier-portal/quotations', pathMatch: 'full' },
  { path: 'rfq-submission/:id', redirectTo: 'supplier-portal/quotations/:id', pathMatch: 'full' },
  { path: 'po-submission', redirectTo: 'supplier-portal/orders', pathMatch: 'full' },
  { path: 'po-submission/:id', redirectTo: 'supplier-portal/orders/:id', pathMatch: 'full' },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'guest-login',
    loadComponent: () => import('./login/guest-login/guest-login.component').then(c => c.GuestLoginComponent)
  },
  {
    // Where ErrorHandlerService sends a rejected session; also reachable directly.
    path: 'no-access',
    loadComponent: () => import('./shared/no-access/no-access-page/no-access-page.component').then(c => c.NoAccessPageComponent)
  },
  {
    // Not linked from any nav - reachable only via direct URL.
    path: 'welcome/faber-quest',
    loadComponent: () => import('./faber-quest-intro/faber-quest-intro.component').then(c => c.FaberQuestIntroComponent)
  },
  {
    path: 'guest-qc-issues',
    loadChildren: () => import('./home/module-project/progress/quality-control/guest-quality-control/guest-qc-routing.module').then(m => m.GuestQcRoutingModule)
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./home/privacy-policy/privacy-policy.component').then(c => c.PrivacyPolicyComponent)
  },
  {
    path: 'terms-conditions',
    loadComponent: () => import('./home/terms-conditions/terms-conditions.component').then(c => c.TermsConditionsComponent)
  },
  {
    path: 'contact-us',
    loadComponent: () => import('./home/contact-us/contact-us.component').then(c => c.ContactUsComponent)
  },
  {
    path: 'export',
    canActivate: [authGuard],
    loadChildren: () => import('./export/export-routing.module').then(m => m.ExportRoutingModule)
  },
  {
    path: "**",
    component: NotFoundComponent,
  }
];

@NgModule({
  imports: [
    // Preloading every lazy chunk is wanted in production/staging (fast navigation after login), but
    // in local development it downloads ~70 chunks with source maps on every reload for no benefit.
    RouterModule.forRoot(routes,
      { preloadingStrategy: environment.production ? PreloadAllModules : NoPreloading })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
